// @flow
import Loadable from 'react-loadable';
import LoadingModal from 'modals/LoadingModal';

export default Loadable({
  loader: () =>
    import(/* webpackChunkName: "DeferQueueItemModalContainer" */ './DeferQueueItemModalContainer'),
  loading: LoadingModal
});
